import React from "react";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { Col, Row } from "reactstrap";
import { isDesktop, isMobile } from "react-device-detect";


export type PresentationSlideColumn = { src?: string; text?: string };

export type PresentationSlide = {
  title?: string;
  description?: string;
  columns?: PresentationSlideColumn[];
};

interface CustomSliderProps {
  items: PresentationSlide[] | PresentationSlideColumn[];
}

const CustomSlider = ({ items }: CustomSliderProps) => {

  return <React.Fragment>
    <div id="custom-slider">
      <OwlCarousel
        className="m-0 owl-theme"
        id="carouselContainer"
        items={1}
        autoplay={false}
        dotsEach={1}
        loop={false}
        nav={true}
        navText={['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>']}
      >
        {
          items?.map((item: PresentationSlide | PresentationSlideColumn, index: number) =>
            <div className="custom-slider__slide" key={index}>
              {(item as PresentationSlide).title && <h1 className="custom-title">{(item as PresentationSlide).title}</h1>}
              {(item as PresentationSlide).description && <p className="custom-description">{(item as PresentationSlide).description}</p>}
              <Row className="justify-content-around m-0">
                {isDesktop && (
                  (item as PresentationSlide).columns?.map((column: PresentationSlideColumn, columnIndex: number) => (
                    <Col lg={4} key={columnIndex}>
                      <img className="mb-2" src={column?.src || ''} />
                      <div className="custom-description" dangerouslySetInnerHTML={{ __html: column?.text || '' }}></div>
                    </Col>
                  ))
                )}
                {isMobile && (<Col key={index}>
                  <div className="inner-slider-content">
                    <img src={(item as PresentationSlideColumn)?.src || ''} />
                    <div className="custom-description" dangerouslySetInnerHTML={{ __html: (item as PresentationSlideColumn)?.text || '' }}></div>
                  </div>
                </Col>
                )}
              </Row>
            </div>
          )
        }
      </OwlCarousel>

    </div>
  </React.Fragment>
}

export default CustomSlider;
